module.exports = __webpack_public_path__ + "static/media/image4.724bb15d.png";